import { FC, Fragment } from 'react';
import { cn } from '../../../utils/classUtils';
import {
  ANCHOR_TAG_REGEX,
  ANCHOR_TAG_REGEX_WITH_TEXT,
  NON_ANCHOR_TEXT_REGEX,
} from '../../../utils/RegexUtils';

interface AgentConfigDrivenSubtitleProps {
  subtitle: string;
  textStyle?: string;
}

const AgentConfigDrivenSubtitle: FC<AgentConfigDrivenSubtitleProps> = ({
  subtitle,
  textStyle,
}) => {
  // Replace \n with actual newlines and split by anchor tags
  const processedText = subtitle.replace(/\\n/g, '\n');

  // Simple regex to split text and preserve anchor tags
  const parts = processedText.split(ANCHOR_TAG_REGEX);

  return (
    <span
      className={cn(
        'font-inter font-normal text-base text-reskin-primary-dark whitespace-pre-line',
        textStyle,
      )}
    >
      {parts.map((part) => {
        // Check if this part is an anchor tag
        const anchorMatch = part.match(ANCHOR_TAG_REGEX_WITH_TEXT);

        if (anchorMatch) {
          const href = anchorMatch[1];
          const linkText = anchorMatch[2];
          return (
            <a
              key={`link-${href}-${linkText}`}
              href={href}
              target='_blank'
              rel='noopener noreferrer'
              className='text-blue-600 underline hover:text-blue-800'
            >
              {linkText}
            </a>
          );
        }

        // For non-anchor text, remove any other HTML tags
        const cleanText = part.replace(NON_ANCHOR_TEXT_REGEX, '');
        return <Fragment key={`text-${cleanText}`}>{cleanText}</Fragment>;
      })}
    </span>
  );
};

export default AgentConfigDrivenSubtitle;
